import { render, staticRenderFns } from "./ClassSchedule.vue?vue&type=template&id=cd8485ca"
import script from "./ClassSchedule.vue?vue&type=script&lang=js"
export * from "./ClassSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports